<template>
  <section class="filter-area">
    <v-container class="py-0">
      <v-row no-gutters class=" w-100 mx-0">
        <v-col cols="12" sm="10" class="mx-auto">
          <v-row no-gutters>
            <!-- <v-col cols="12" sm="4">
              <v-img :src="require('@/assets/imgs/filter.svg')"></v-img>
            </v-col>
            <v-col cols="12" sm="8" class="align-self-center">
              <article class="filter-area__head">
                <h2>Hello,</h2>
                <p>Let's Go Make a Difference Today</p>
              </article>
            </v-col> -->
            <v-col cols="12">
              <v-text-field
                outlined
                :loading="loading"
                :disabled="loading"
                :append-icon="filter.search ? 'mdi-close' : ''"
                @click:append="clearSearchData()"
                v-model="filter.search"
                :placeholder="$t('button.search')"
                prepend-inner-icon="mdi-magnify"
                v-on:keyup.enter="filterParents"
                :hide-details="!!hint || hideDetails"
              ></v-text-field>

              <small v-if="hint" class="mb-3 mx-2 mt-1 d-block">
                Hint: {{ hint }}
              </small>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: () => {}
    },
    hint: {
      type: String,
      default: ""
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter: {
        search: ""
      }
    };
  },
  methods: {
    filterParents() {
      const query = {};
      let routeQuery = { ...this.$route.query };
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key]) {
          query[key] = this.filter[key];
        }
      });
      if (routeQuery.page > 1) {
        routeQuery.page = 1;
      }

      this.$router.push({ query: { ...routeQuery, ...query } });
    },
    clearSearchData() {
      let routeQuery = { ...this.$route.query };
      this.filter.search = "";
      delete routeQuery.search;
      this.$router.push({ query: routeQuery });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler({ query }) {
        this.filter.search = query.search;
      }
    }
  }
};
</script>
